module.exports = __webpack_public_path__ + "img/seating_monitor.ca55cb57.png";